import { useTheme } from '@mui/styles';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    fieldsContainer: {
      display: 'flex',
      alignItems: 'center',
    },
    dialogContentRoot: {
      paddingTop: 0,
      paddingLeft: theme.spacing(1.5),
    },
  };
};
